import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { TranslateService } from '@ngx-translate/core';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { ErrorHandlerService } from '../../core/services/error-handler.service';
import { RemoteCheckAccommodationStatusService } from '../../services';
import { NotificationService } from '../../ui/services/notification.service';

import * as fromActions from './actions';

@Injectable()
export class RemoteCheckAccommodationStatusStoreEffects {
  constructor(
    private dataService: RemoteCheckAccommodationStatusService,
    private actions$: Actions,
    private errorHandler: ErrorHandlerService,
    private notifications: NotificationService,
    private translate: TranslateService,
  ) {}

  checkStatus$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.checkRequest),
      switchMap(({ propertyId, channelId, accommodationChannelId }) =>
        this.dataService
          .check(propertyId, channelId, accommodationChannelId)
          .pipe(
            map(() => {
              this.notifications.push({
                title: this.translate.instant('done'),
                content: this.translate.instant(
                  'notifications.generic_success',
                  {
                    param: this.translate.instant(
                      'remote_check_accommodation_status',
                    ),
                  },
                ),
                type: 'success',
              });
              return fromActions.checkSuccess();
            }),
            catchError((error) => {
              this.errorHandler.handle(error);
              return of(fromActions.checkFailure(error));
            }),
          ),
      ),
    ),
  );
}
